import React from 'react';
import GraficoLinha from './line';

import * as c from '../../../helpers/constants';
import { getToken, isAuthenticated } from '../../../store/auth';
import { Content, IBox, Title } from '../../inspinia';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

class HorarioAberturaEmail extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            endpoint: '/relatorio/abertura-hora',
            usuario: {},
            auth: this.props.auth,
            data: [],
            loading: true
        }

        this.buildData = this.getData.bind(this);
    }

    getDataEmpty() {
        let dadosGrafico = Array();
        for (let i = 0; i < 24; i++) {
            let horario = i.toString();
            if (i <= 9) {
                horario = '0' + horario;
            }

            dadosGrafico.push({ 'dataHoraAberturaEmail': horario, 'quantidadeEmailsAbertos': 0 });
        }

        return dadosGrafico;
    }

    getData(json) {
        let dadosGrafico = this.getDataEmpty();
        dadosGrafico.map((obj) => this.preencheDataGrafico(json, obj));

        return dadosGrafico;
    }

    preencheDataGrafico(json, dadoGrafico) {
        json.map(function (obj) {
            if (dadoGrafico.dataHoraAberturaEmail === obj.dataHoraAberturaEmail) {
                dadoGrafico.quantidadeEmailsAbertos = obj.quantidadeEmailsAbertos;
            }
        });
    } 

    componentDidMount() {
        if (!isAuthenticated) {
            throw (c.MESSAGE_ERROR(c.AUTH_ERROR));
        }

        const _token = c.AUTH_HEADER(getToken());

        const url = `${c.API_BASE_URL}${this.state.endpoint}`;
        const options = {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'content-type': 'application/json',
                'Authorization': _token
            }
        };

        fetch(url, options).then(async (response) => {
            this.setState({ loading: true });
            let json = await response.json();

            if (response.ok) {
                this.setState({ loading: false, data: this.getData(json) });
            } else {
                c.TOASTER_ERROR(json.message);
            }
        }).catch((exception) => {
            console.log("fetch error" + exception);
        });
    }

    render() {
        if (this.state.loading) {
            return (
                <div className="sk-spinner sk-spinner-three-bounce">
                    <div className="sk-bounce1"></div>
                    <div className="sk-bounce2"></div>
                    <div className="sk-bounce3"></div>
                </div>
            );
        }

        return (
            <IBox>
                <Title><h3>Horários de abertura</h3></Title>

                <Content>
                    <GraficoLinha
                        data={this.state.data}
                        dataKeyXAxis="dataHoraAberturaEmail"
                        dataKeyLine="quantidadeEmailsAbertos"
                        label="Horário -> Qtd. Emails"
                        intro="Histórico de 7 dias"
                    />
                </Content>
            </IBox>
        );
    }

}

function mapStateToProps(state) {
    return { auth: state.auth };
}

export default withRouter(connect(mapStateToProps)(HorarioAberturaEmail));